import { render } from "./MyListQuotes.vue?vue&type=template&id=fc889854&scoped=true"
import script from "./MyListQuotes.vue?vue&type=script&lang=js"
export * from "./MyListQuotes.vue?vue&type=script&lang=js"

import "./MyListQuotes.vue?vue&type=style&index=0&id=fc889854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc889854"]])

export default __exports__